import { ICancelablePromise } from '@Core/Animation/SpineWrapper';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { GameScene } from '@Core/GameScene/GameScene';
import AssetsLoadManager from '@Core/Loader/AssetsLoadManager';
import { ESymbolAnimations } from '@Core/Reels/SymbolAnimations';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { ISymbolsHighlightPresenter, WaysCycleStep } from '../SymbolsHighlighter.types';

export class ScattersPresenter extends GameComponent implements ISymbolsHighlightPresenter {
    public scene: GameScene;
    private cycleDuration: number;
    private static readonly DEFAULT_CYCLE_TIME = 1000;

    constructor(
        scene: GameScene,
        private readonly scatterIds: number[]
    ) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, { class: ScattersPresenter.name, source: LoggerSource.Game, message: 'Scatters constructor' });
    }

    public onInit(): void {}

    public onCreate(): void {
        const spineAsset = AssetsLoadManager.getSpinesConfiguration().assets.find((spine) => spine.key === `symbol_${this.scatterIds[0]}`);

        const animationDurationMs =
            spineAsset?.key && spineAsset?.atlas
                ? (this.game.spines.find((spine) => spine.dataKey === spineAsset.key)?.spine.skeleton.data?.findAnimation(ESymbolAnimations.WIN)?.duration ??
                      1) * 1000
                : 1000;

        this.cycleDuration = animationDurationMs;
    }

    public show(step: WaysCycleStep): ICancelablePromise[] {
        const visibleSymbols = this.gameStore.get(EGameStoreKeys.VisibleSymbols);
        const promises: ICancelablePromise[] = [];
        for (let reel = 0; reel < step.selectionMask.length; reel++) {
            for (let row = 0; row < step.selectionMask[reel].length; row++) {
                if (!step.selectionMask[reel][row]) continue;
                const symbol = visibleSymbols[reel][row];
                promises.push(symbol.symbolAnimation.waitForAnimationEvent(symbol.getAnimationVariant(ESymbolAnimations.WIN, step), 'complete'));
            }
        }
        const timerPromise: ICancelablePromise = {
            promise: new Promise((resolve) => {
                this.scene.time.delayedCall(ScattersPresenter.DEFAULT_CYCLE_TIME, resolve);
            }),
            cancel: () => {}
        };
        promises.push(timerPromise);
        EventsCenter.emit(EGameEvents.CYCLE_SCATTERS, step);
        return promises;
    }

    hide(): void {
        // empty method
    }

    getAnimationDuration(): number {
        return this.cycleDuration;
    }
}
